/** One page of a chat's history, as `GET /api/chatrooms/:id/messages` answers it. */
export interface EmbeddedMessagesPage {
  messages: unknown[]
  hasMore: boolean
  count: number
}

/**
 * Narrow the history route's body to a page. The route answers the page either
 * bare or inside the `{ success, data }` envelope, so both depths are accepted and
 * anything else is `null` — never a value handed on to a `.reverse()` that throws.
 */
export function readEmbeddedMessagesPage(body: unknown): EmbeddedMessagesPage | null {
  if (isEmbeddedMessagesPage(body)) return body
  if (isSuccessEnvelope(body) && isEmbeddedMessagesPage(body.data)) return body.data
  return null
}

function isEmbeddedMessagesPage(value: unknown): value is EmbeddedMessagesPage {
  return (
    typeof value === "object" &&
    value !== null &&
    "messages" in value &&
    Array.isArray(value.messages) &&
    "hasMore" in value &&
    typeof value.hasMore === "boolean" &&
    "count" in value &&
    typeof value.count === "number"
  )
}

function isSuccessEnvelope(value: unknown): value is { success: true; data: unknown } {
  return (
    typeof value === "object" &&
    value !== null &&
    "success" in value &&
    value.success === true &&
    "data" in value
  )
}
